import axios from "axios";

const MEDIUM_RSS_URL = "https://medium.com/feed/@pedrux";
const RSS_TO_JSON_API = "https://api.rss2json.com/v1/api.json";

export default {
  async getPosts() {
    const response = await axios.get(RSS_TO_JSON_API, {
      params: {
        rss_url: MEDIUM_RSS_URL,
      },
    });
    return response.data;
  },
};
